import { put } from "redux-saga/effects";
import importer from "common/importer";
const PublicContentActions = importer("Stores/PublicContent/Actions");
import { getMinStaticContent } from "@takedapdt/biolife-cms-kit";
import i18next from "i18next";

export default function* main({ refType }) {
  try {
    yield put(PublicContentActions.getPatientTestimonialsLoading());
    const data = (yield getMinStaticContent("testimonials", {
      lang: i18next.language,
      filters: { field_slug_value: refType },
    }))[0];
    yield put(PublicContentActions.getPatientTestimonialsSuccess(data));
  } catch (error) {
    console.log("error", { error });
    yield put(PublicContentActions.getPatientTestimonialsFailure(error));
  }
}
